import './index.scss'
import ReactOtpInput from 'react-otp-input'

import React from 'react'

interface OtpInputProps {
	/** Value of the OTP input */
	value?: string
	/** Callback to be called when the OTP value changes */
	onChange: (otp: string) => void
}

export function OtpInput({ value, onChange }: OtpInputProps) {
	return (
		<ReactOtpInput
			value={value}
			onChange={onChange}
			numInputs={6}
			renderInput={(props) => <input {...props} />}
			skipDefaultStyles
			containerStyle="otp-container"
			inputStyle="otp-input"
		/>
	)
}
